<section class="mu-home">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 offset-lg-0 col-md-11 offset-md-1 col-12">
        <div class="col-12">
          <div class="row">
            <app-back-button [pageTitle]="pageTitle" [backRouting]="dashboardPageLink"></app-back-button>
            <app-summary-data-table [options]="summaryOptions" [data]="summaryData" />
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
